import React from 'react';
import PropTypes from 'prop-types';
import I18n from '~shared/utils/i18n';
import {
    DISMISS_BUTTON_CLASS,
    I18_DISMISS,
    GTM_DISMISS_INSTRUCTION,
}
from './constants/constants';
import { removeInstructionCard } from './utils/utils';
import './styles/dismissButton.scss';

class DismissButton extends React.Component {
    constructor(props) {
        super(props);
      }

    render() {

        return (
            <button
                className={DISMISS_BUTTON_CLASS}
                onClick={() => removeInstructionCard(this.props.type)}
                data-spectate-product={`${this.props.gtmAttribute}${GTM_DISMISS_INSTRUCTION}`}>
                    {I18n.t(I18_DISMISS)}
            </button>
        );
    }
}

DismissButton.propTypes = {
    gtmAttribute: PropTypes.string,
    type: PropTypes.string.isRequired,
};

DismissButton.defaultProps = {
    gtmAttribute: '',
};

export default DismissButton;
